import { Calendar } from 'lucide-react';
import { getTodayDayNumber, DAILY_RECOMMENDATION_MENU_NAME } from '@/utils/dailyRecommendationMenu';

interface DailyRecommendationMenuLabelProps {
  iconSize?: 'sm' | 'md';
  labelClassName?: string;
  className?: string;
}

function CalendarDayIcon({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  const iconClass = size === 'md' ? 'h-5 w-5' : 'h-6 w-6';
  const dayClass =
    size === 'md'
      ? 'bottom-[2px] text-[8px]'
      : 'bottom-[3px] text-[9px]';

  return (
    <span className="relative inline-flex shrink-0 items-center justify-center">
      <Calendar className={`${iconClass} text-primary-600`} strokeWidth={2} aria-hidden />
      <span
        className={`absolute left-1/2 -translate-x-1/2 ${dayClass} font-medium leading-none text-primary-600`}
      >
        {getTodayDayNumber()}
      </span>
    </span>
  );
}

export default function DailyRecommendationMenuLabel({
  iconSize = 'sm',
  labelClassName = '',
  className = '',
}: DailyRecommendationMenuLabelProps) {
  return (
    <span className={`flex items-center gap-1.5 ${className}`}>
      <CalendarDayIcon size={iconSize} />
      <span className={labelClassName}>{DAILY_RECOMMENDATION_MENU_NAME}</span>
    </span>
  );
}
